import "./Loading.css";
import React from "react"; 

export function Loading() {
  return <span className="loader"></span>;
}
